import { Link } from 'react-router-dom';

export default function HeroSection() {
  const siteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '36漫画网 - 洞洞杂货铺漫画',
    url: 'https://36manhua.com',
    description: '在线免费阅读洞洞杂货铺漫画就选36漫画网，界面简洁、操作便捷，开启沉浸式追漫之旅。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://36manhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '36漫画网',
    url: 'https://36manhua.com',
    description: '专业的在线免费漫画阅读平台',
    sameAs: [
      'https://weibo.com/36manhua',
      'https://www.zhihu.com/people/36manhua',
    ],
  };

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20artistic%20illustration%20of%20a%20vintage%20curiosity%20shop%20interior%20with%20magical%20atmosphere%2C%20soft%20golden%20light%20streaming%20through%20windows%2C%20wooden%20shelves%20filled%20with%20mysterious%20objects%2C%20Chinese%20manhua%20inspired%20art%20style%2C%20dreamy%20warm%20tones%2C%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=hero-comic-bg&orientation=landscape"
        alt="洞洞杂货铺漫画"
        title="洞洞杂货铺漫画 - 36漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-xs text-background-50/90">每日更新 · 免费阅读</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          洞洞杂货铺
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
          每一件物品，都藏着一个故事。走进洞洞杂货铺，开启你的奇幻追漫之旅
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/article/comic-001"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始阅读
          </Link>
          <Link
            to="/category/qihuan"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap border border-background-50/20"
          >
            <i className="ri-compass-3-line mr-2"></i>
            探索更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">16+</p>
            <p className="text-xs text-background-50/60 mt-1">精选漫画</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">50万+</p>
            <p className="text-xs text-background-50/60 mt-1">累计读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">99.5%</p>
            <p className="text-xs text-background-50/60 mt-1">好评率</p>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
    </section>
  );
}